import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EQAUTH_ENV } from '@auth-admin/app/core/tokens';
import { AUTH_ENV } from '@auth/app/core/tokens';
import { AuthService } from '@auth/app/core/services/auth.service';
import { startsWithApiBase } from '@auth/app/core/utils/api-url.util';

/** Injeta `X-Tenant-ID` e `X-Application-ID` nas chamadas ao eq-auth-api autenticadas. */
export const authContextInterceptor: HttpInterceptorFn = (req, next) => {
  const authEnv = inject(AUTH_ENV);
  const eqauthEnv = inject(EQAUTH_ENV);

  const isEqAuthApi =
    startsWithApiBase(req.url, authEnv.url) || startsWithApiBase(req.url, eqauthEnv.url);
  if (!isEqAuthApi) {
    return next(req);
  }

  const context = inject(AuthService).getContext();
  if (!context) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Tenant-ID': context.tenantId,
        'X-Application-ID': context.applicationId,
      },
    }),
  );
};
